var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobileOnly)?_c('div',[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require('@/assets/img/logo.png')}})]),_c('router-view')],1):_c('div',[_vm._v("Only For Mobile")])])
}
var staticRenderFns = []

export { render, staticRenderFns }